// src/app/shared/menu-branch.component.ts
import { Component, Input } from "@angular/core";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { NgFor, NgIf } from "@angular/common";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MenuItem } from "./menu.model";

@Component({
  selector: "app-menu-branch",
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    RouterLink,
    RouterLinkActive,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: "./menu-branch.component.html",
  styleUrls: ["./menu-branch.component.scss"],
})
export class MenuBranchComponent {
  @Input() items: MenuItem[] = [];
  @Input() roles: string[] = [];

  isVisible = (mi: MenuItem) =>
    mi.visible ? mi.visible({ roles: this.roles }) : true;
}
